import { useEffect } from 'react';

import { useDMAccess } from '@/components/pages/conversations/SocialInbox/hooks/useDMAccess';
import { useSocialInboxNavigation } from '@/components/pages/conversations/SocialInbox/hooks/useSocialInboxNavigation';

import { SOCIAL_INBOX_META } from '@/components/pages/conversations/SocialInbox/const';

/**
 * Hook to navigate from MENTIONS/DM to comments tab when:
 * 1. The selected profile does not support Direct Messages
 * 2. Or any group is selected
 */
export const useNavigateToComments = () => {
    const { currentSocialInbox, navigateTo } = useSocialInboxNavigation();
    const hasDMAccess = useDMAccess();

    useEffect(() => {
        // Check if we need to navigate from mentions to comments
        const isMentionsTab = currentSocialInbox === SOCIAL_INBOX_META.mention.key;
        const isDMTab = currentSocialInbox === SOCIAL_INBOX_META.dm.key;

        if ((isMentionsTab || isDMTab) && !hasDMAccess) {
            navigateTo(SOCIAL_INBOX_META.comment.key);
        }
    }, [hasDMAccess, currentSocialInbox, navigateTo]);
};
